import { useState, useEffect } from "react";

import About from "./Components/About";
import Education from "./Components/Education";
import Experience from "./Components/Experience";
import Projects from "./Components/Projects";
import Skills from "./Components/Skills";
import Certificates from "./Components/Certificates";
import Profiles from "./Components/Profiles";

import { pages, headerLinks } from "./Data";

import { Row, Col, Navbar, Button, Offcanvas } from "react-bootstrap";

import styles from "./Styles.module.css";

import { FaExternalLinkAlt } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";

const Header = () => {
    const [active, setActive] = useState("About");

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const clickHandler = (page) => {
        handleClose();
        setActive(page);
    };

    const [screenSize, getDimension] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const setDimension = () => {
        getDimension({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimension);

        return () => {
            window.removeEventListener("resize", setDimension);
        };
    }, [screenSize]);

    return (
        <>
            <Navbar sticky="top" className="d-flex justify-content-between">
                <div>
                    <h5>
                        <b style={{textShadow: "2px 2px red"}}>Arghya Deep Pal</b>
                    </h5>
                    Software Engineer at&nbsp;
                    <a
                        href="https://www.tcs.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "skyblue" }}
                    >
                        <i>
                            <b>TCS</b>
                        </i>
                    </a>
                </div>
                <div className="d-none d-md-flex">
                    <div className="d-flex justify-content-between me-3">
                        {headerLinks.map((link) => (
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color:
                                        link.color === "black"
                                            ? "white"
                                            : link.color,
                                    // backgroundImage: "linear-gradient(black, yellow)"
                                }}
                                className="me-3"
                            >
                                {link.icon}
                            </a>
                        ))}
                    </div>
                    <h5>
                        <a
                            href="mailto:arghyadeep100@gmail.com?subject=Resume Required&body=Hi, please send your resume for"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Button variant="outline-info" size="sm">
                                Resume <FaExternalLinkAlt size={15} />
                            </Button>
                        </a>
                    </h5>
                </div>
                <h5
                    className="d-md-none"
                    onClick={handleShow}
                    style={{ cursor: "pointer" }}
                >
                    {show === false ? (
                        <FaBars size="30" />
                    ) : (
                        <IoMdClose size="40" />
                    )}
                </h5>
            </Navbar>

            {/* OffCanvas */}
            <Offcanvas
                show={screenSize.width < 770 && show}
                onHide={handleClose}
            >
                <Offcanvas.Header closeButton>
                    <h3>Arghya Deep Pal</h3>
                </Offcanvas.Header>
                <div className="text-center">
                    Software Engineer at&nbsp;
                    <a
                        href="https://www.tcs.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue" }}
                    >
                        <i>
                            <b>TCS</b>
                        </i>
                    </a>
                </div>
                <Offcanvas.Body className="mt-3">
                    {pages.map((page) => (
                        <h6
                            onClick={() => clickHandler(page)}
                            style={{
                                color: active === page && "blue",
                                borderBottom:
                                    active === page && "2px solid blue",
                                cursor: "pointer",
                            }}
                            className="mb-4"
                            key={page}
                        >
                            <b>{page}</b>
                        </h6>
                    ))}
                    <div style={{ position: "absolute", bottom: "4vh" }}>
                        <b>Get in touch:</b>
                        <div className="d-flex justify-content-between mt-2">
                            {headerLinks.map((link) => (
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: link.color }}
                                    className="me-3"
                                >
                                    {link.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            bottom: "3vh",
                            right: "15px",
                        }}
                    >
                        <h3>
                            <a
                                href="mailto:arghyadeep100@gmail.com?subject=Resume Required&body=Hi, please send your resume for"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Button variant="outline-primary" size="sm">
                                    Resume <FaExternalLinkAlt size={15} />
                                </Button>
                            </a>
                        </h3>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <Row className="mt-2">
                {/* Web tabs */}
                <Col md={2} className="mt-1 d-none d-md-block">
                    {pages.map((page) => (
                        <h6
                            onClick={() => setActive(page)}
                            style={{
                                color: active === page && "skyblue",
                                borderBottom:
                                    active === page && "2px solid skyblue",
                                cursor: "pointer",
                            }}
                            className="p-2"
                            key={page}
                        >
                            {page}
                        </h6>
                    ))}
                </Col>

                {/* Content */}
                <Col
                    sm={12}
                    md={10}
                    style={{ position: "relative" }}
                    className="mt-2"
                >
                    <div className={styles.common}>
                        {/* <h5>{active}</h5> */}
                        {active === "About" && <About />}
                        {active === "Education" && <Education />}
                        {active === "Experience" && <Experience />}
                        {active === "Projects" && <Projects />}
                        {active === "Skills" && <Skills />}
                        {active === "Certificates" && <Certificates />}
                        {active === "Profiles" && <Profiles />}
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Header;
